export default __webpack_public_path__ + "assets/36752584ff1f9adec18a29da8e2c72b7.svg";